export default "/build/images/3foot.png?7b8766839d05c35d7269b377c5755d30";